import { render, staticRenderFns } from "./GoogleUserBanner.vue?vue&type=template&id=661358ca&scoped=true&"
import script from "./GoogleUserBanner.vue?vue&type=script&lang=js&"
export * from "./GoogleUserBanner.vue?vue&type=script&lang=js&"
import style0 from "./GoogleUserBanner.vue?vue&type=style&index=0&id=661358ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661358ca",
  null
  
)

export default component.exports